import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDataIdentifierSSC } from 'app/shared/model/data-identifier-ssc.model';
import { getEntities } from './data-identifier-ssc.reducer';

export const DataIdentifierSSC = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const dataIdentifierSSCList = useAppSelector(state => state.dataIdentifierSSC.entities);
  const loading = useAppSelector(state => state.dataIdentifierSSC.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  return (
    <div>
      <h2 id="data-identifier-ssc-heading" data-cy="DataIdentifierSSCHeading">
        <Translate contentKey="integrawebApp.dataIdentifierSSC.home.title">Data Identifier SSCS</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="integrawebApp.dataIdentifierSSC.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/data-identifier-ssc/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="integrawebApp.dataIdentifierSSC.home.createLabel">Create new Data Identifier SSC</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {dataIdentifierSSCList && dataIdentifierSSCList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.description">Description</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.shortDesc">Short Desc</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.shortDescInt">Short Desc Int</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.type">Type</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.length">Length</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.special">Special</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.createdDate">Created Date</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.createdBy">Created By</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.lastModifiedDate">Last Modified Date</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.dataIdentifierSSC.lastModifiedBy">Last Modified By</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dataIdentifierSSCList.map((dataIdentifierSSC, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/data-identifier-ssc/${dataIdentifierSSC.id}`} color="link" size="sm">
                      {dataIdentifierSSC.id}
                    </Button>
                  </td>
                  <td>{dataIdentifierSSC.description}</td>
                  <td>{dataIdentifierSSC.shortDesc}</td>
                  <td>{dataIdentifierSSC.shortDescInt}</td>
                  <td>{dataIdentifierSSC.type}</td>
                  <td>{dataIdentifierSSC.length}</td>
                  <td>{dataIdentifierSSC.special}</td>
                  <td>
                    {dataIdentifierSSC.createdDate ? (
                      <TextFormat type="date" value={dataIdentifierSSC.createdDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{dataIdentifierSSC.createdBy}</td>
                  <td>
                    {dataIdentifierSSC.lastModifiedDate ? (
                      <TextFormat type="date" value={dataIdentifierSSC.lastModifiedDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{dataIdentifierSSC.lastModifiedBy}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/data-identifier-ssc/${dataIdentifierSSC.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/data-identifier-ssc/${dataIdentifierSSC.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/data-identifier-ssc/${dataIdentifierSSC.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="integrawebApp.dataIdentifierSSC.home.notFound">No Data Identifier SSCS found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DataIdentifierSSC;
